<div *ngIf="module" fxLayout="column" fxLayoutGap="10px">
  <div fxLayout="row" fxFlexAlign="center">
    <h2>{{moduleName | translate}}
      <mat-icon color="primary" *ngIf="isSaveSuccess === true">check_circle</mat-icon>
      <mat-icon color="error" *ngIf="isSaveSuccess === false">cancel</mat-icon>
    </h2>
  </div>
  <div fxLayout="row" fxFill>
    <mat-table [dataSource]="guiDataSource" matSort #sortForDataSource="matSort" fxFill>

      <!-- Column Definition: from -->
      <ng-container matColumnDef="from">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'date.from' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <gt-datetime-input [(datetime)]="row.from" [disabled]="!row.editing">
          </gt-datetime-input>
        </mat-cell>
      </ng-container>

      <!-- Column Definition: to -->
      <ng-container matColumnDef="to">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'date.to' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <gt-datetime-input [(datetime)]="row.to" [disabled]="!row.editing">
          </gt-datetime-input>
        </mat-cell>
      </ng-container>

      <!-- Column Definition: next -->
      <ng-container matColumnDef="next">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'modules.next' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-form-field style=" margin-bottom: -1.3em" *ngIf="module.legalNextComponents.length > 1; else showStaticText">
            <mat-select [(ngModel)]="row.nextCid" [disabled]="!row.editing">
              <mat-option *ngFor="let next of module.legalNextComponents" [value]="next.cid">
                {{ next.displayName || componentMap[next.cid].name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-template #showStaticText>
            <div [ngClass]="row.editing? '': 'disabled'">{{componentMap[row.nextCid]? componentMap[row.nextCid].name :  ''}}</div>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Column Definition: actions -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="right-aligned-table-column">
          <button mat-icon-button (click)="addRow()" color="primary"  matTooltip="{{'global.add' | translate}}">
            <mat-icon>playlist_add</mat-icon>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="right-aligned-table-column">
          <button mat-icon-button (click)="deleteRow(row)" *ngIf="!row.editing" matTooltip="{{'global.delete' | translate}}">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button (click)="row.editing = true;" *ngIf="!row.editing" matTooltip="{{'global.edit' | translate}}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button *ngIf="row.editing" (click)="cancelRow(row)"
            matTooltip="{{'global.cancel' | translate}}" color="primary">
            <mat-icon>cancel</mat-icon>
           </button>
           <button mat-icon-button (click)="saveRow(row)" *ngIf="row.editing"
            matTooltip="{{'global.save' | translate}}" color="primary">
            <mat-icon>save</mat-icon>
           </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="dateDataSourceColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: dateDataSourceColumns;">
      </mat-row>
    </mat-table>
  </div>
</div>
